import { createReducer, createNamespacer } from '../commons/js/utils/reducer';
import { combineReducers } from "redux";

const namespacers = {
    taskboard: createNamespacer("TASKBOARD"),
    paginatedSpools: createNamespacer("PAGINATED_SPOOLS")
}

const initialState = {
    list : {
        spools: {},
        error: "",
        isLoading: false,
    },
    paginated: {
        spools: {},
        currentPage: 2,
        pageCount: 0,
        isLoading: false,
    }
}

const taskboardReducer = createReducer(initialState.list, {
    [namespacers.taskboard("SET_SPOOLS")]: (state, action) => {
        return {
            ...state,
            spools: {
                ...state.spools,
                [action.payload.columnName]: {
                    key:action.payload.key,
                    data:[...action.payload.value],
                    view_more : action.payload.viewMore
                }
            },
        }
    },
    [namespacers.taskboard("SET_SPOOLED")]: (state, action) => {
        return {
            ...state,
            spools: {
                [action.payload.columnName]: {
                    key:action.payload.key,
                    data:[...action.payload.value],
                    view_more : action.payload.viewMore
                }
            },
        }
    },
    // [namespacers.taskboard("SET_PAGE")]: (state, action) => {
    //     return {
    //         ...state,
    //         currentPage: action.payload.value,
    //     }
    // },

    [namespacers.taskboard("SET_ERROR")]: (state, action) => {
        return {
            ...state,
            error: action.payload.value,
        }
    },

    [namespacers.taskboard("SET_LOADING")]: (state, action) => {
        return {
            ...state,
            isLoading: action.payload.value,
        }
    },

})

const spoolsReducer = createReducer(initialState.paginated, {
    [namespacers.paginatedSpools("SET_SPOOLS")]: (state, action) => {
        return {
            ...state,
            spools: action.payload.value,
            pageCount: action.payload.pages,
        }
    },
    [namespacers.paginatedSpools("SET_PAGE")]: (state, action) => {
        return {
            ...state,
            currentPage: action.payload.value,
        }
    },
    [namespacers.paginatedSpools("SET_LOADING")]: (state, action) => {
        return {
            ...state,
            isLoading: action.payload.value,
        }
    },
})

const reducer = combineReducers({
    list: taskboardReducer,
    paginated: spoolsReducer
})

export default reducer